<script>
import ViewTitle from '@/components/ViewTitle'
import WideIconTile from '@/components/WideIconTile'
import FloatingLabelTextInput from '@/components/FloatingLabelTextInput'
import StoreLoyaltyCardFrame from '@/frames/storeLoyaltyCardFrame'
import AccountsServices from '@/services/accounts'
import EnvironmentUtils from '@/utils/environmentUtils'
import Fuse from 'fuse.js'

export default
{
    name: 'loyalty-card-edit-history',

    created ()
    {
        StoreLoyaltyCardFrame.initFrame(this.$store, this.storeId, true)
    },

    render () 
    {
        const transactions = this.transactionsToDisplay
        const displayedDate = []

        return (
            <div id='loyalty-card-edit-history-view'>
                <view-title back-action={true}>Historique des transactions</view-title>
                <floating-label-text-input id='search-field' class='light-gray-style' placeholder={`Filtrer l'historique`}
                            icon={require('@/assets/img/magnifying-glass-thin.svg')} placeholder-disappear-on-text={true} v-model={this.searchFieldValue} />
                {transactions.map(t =>
                {
                    const toDisplay = []
                    const dayDate = new Intl.DateTimeFormat('fr-FR', {weekday: 'long', day: 'numeric', month: 'long'}).format(new Date(t.timestamp.toDateString()))
                    if (!displayedDate.includes(dayDate))
                    {
                        displayedDate.push(dayDate)
                        toDisplay.push(<div class='day-date'>{dayDate}</div>)
                    }
                    toDisplay.push(t.node)
                    
                    return toDisplay
                })}
            </div>
        )
    },

    data () 
    {
        return {
            searchFieldValue: this.$route.query.search,
            accounts: {},
        }
    },

    mounted ()
    {
    },

    computed:
    {
        storeId ()
        {
            return this.$route.params.storeId
        },

        allTransactions ()
        {
            let transactions = []
            transactions.push(...this.$store.state.storeLoyaltyCard.storeCreditHistory[this.storeId].map(t =>
            {
                const account = this.$store.state.accounts.accounts[t.byAccountId]
                if (t.byAccountId && !account)
                {
                    try
                    {
                        AccountsServices.searchAccount(t.byAccountId, EnvironmentUtils.cityId).then(acc =>
                        {
                            this.$store.commit('accounts/updateAccounts', [acc])
                        })
                    }
                    catch (e) { console.error(e) }
                    return null
                }

                return {...t, account,firstName: account.firstName, node: <wide-icon-tile title={<div>Carte {t.cardId} <span class='credit'>+{t.amount} points</span></div>}
                    subtitle={`Le ${this.timestampToString(t.timestamp)} ${account ? `par ${account.firstName}` : ''}`} right-content={false} />}
            }))
            transactions.push(...this.$store.state.storeLoyaltyCard.storeRewardHistory[this.storeId].map(r =>
            {
                return {...r, node: <wide-icon-tile title={<div>Carte {r.cardId} <span class='debit'>-{r.amount} points</span></div>}
                    subtitle={`Le ${this.timestampToString(r.timestamp)} en échange de ${r.reward}`} right-content={false} />}
            }))

            transactions = transactions.filter(t => t)
            transactions.forEach(t => t.timestamp = new Date(t.timestamp))
            transactions = transactions.sort((a, b) => b.timestamp - a.timestamp)

            return transactions
        },

        transactionsToDisplay ()
        {
            if (this.searchFieldValue)
            {
                const keys = ['cardId', 'reward', 'firstName']
                const fuse = new Fuse(this.allTransactions, { threshold: 0.3, keys })
                return fuse.search(this.searchFieldValue.toString())
            }
            return this.allTransactions
        }
    },

    watch:
    {
        searchFieldValue (now)
        {
            this.$router.replace({ query:  {...this.$route.query, search: now} })
        }
    },

    methods:
    {
        timestampToString (timestamp)
        {
            return `${new Intl.DateTimeFormat('fr-FR').format(new Date(timestamp))} à
             ${new Intl.DateTimeFormat('fr-FR', {hour: 'numeric', minute: 'numeric'}).format(new Date(timestamp))}`
        }
    },

    components:
    {
        ViewTitle,
        WideIconTile,
        FloatingLabelTextInput
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

#loyalty-card-edit-history-view
{
    margin-bottom: calc(var(--theme-horizontal-menu-height) + 2vh);
    margin-left: 10px;
    margin-right: 10px;

    .OnTablet({
        margin-left: auto;
        margin-right: auto;
        max-width: 550px;
    });
    .OnDesktop({ margin-top: 8vh; });

    .day-date
    {
        .CapitalizeFirstLetter();
        margin-top: 20px;
        margin-bottom: 7px;
        font-size: 12px;
    }

    .credit
    {
        color: var(--theme-success-color);
    }
    .debit
    {
        color: var(--theme-danger-color);
    }
}
</style>



// WEBPACK FOOTER //
// src/views/LoyaltyCardEditHistory.vue